import { Button, Dialog, Modal, ModalRef } from 'alurkerja-ui';
import React, { useRef } from 'react';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import {
  IDetailTestRunSchema,
  TestRunDetailService,
} from '@/api/testRunDetail';
import { FaTrash } from "react-icons/fa";

type DeleteTestRunDetailProps = {
  testRunDetail: IDetailTestRunSchema;
  onSuccess?: () => void;
};

export const DeleteTestRunDetail: React.FC<DeleteTestRunDetailProps> = ({
  testRunDetail,
  onSuccess,
}) => {
  const ref = useRef<ModalRef>(null);
  const { mutate: deleteMutate, isPending: isDeleteLoading } =
    TestRunDetailService.useDelete();

  const deleteAction = () => {
    deleteMutate(testRunDetail, {
      onSuccess: () => {
        Dialog.success({
          title: 'Success',
          description: 'Test case has been deleted',
          callback: () => {
            onSuccess?.();
            ref.current?.closeModal();
          },
        });
      },
      onError: () => {
        Dialog.error({
          title: 'Error',
          description: 'Failed to delete test case',
        });
      },
    });
  };

  return (
    <Modal
      ref={ref}
      triggerButton={
        <Button
          className="bg-red-600"
        >
          <FaTrash />
        </Button>
      }
      title="Delete Test Case"
    >
      {({ closeModal }) => {
        return (
          <div className="flex flex-col gap-4 p-4">
            <p className="text-gray-500">
              Are you sure you want to delete this test case? This action cannot
              be undone.
            </p>

            <div className="flex flex-row gap-2">
              <OutlineButton onClick={closeModal}>Cancel</OutlineButton>

              <Button
                type="button"
                color="red"
                onClick={deleteAction}
                loading={isDeleteLoading}
              >
                Delete
              </Button>
            </div>
          </div>
        );
      }}
    </Modal>
  );
};
